export const userRole = [
  {
    label: "System Admin",
    value: "system_admin",
  },
  {
    label: "Report Viewer",
    value: "report_viewer",
  },
];
